<template>
    <div class="mv-table">
        <b-row>
            <b-col md="12" class="mb-4" v-if="localShowFilter">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input
                            v-model="filter"
                            :size="size"
                            debounce="500"
                            placeholder="Ergebnisse filtern"
                        />
                        <b-input-group-append>
                            <b-button :disabled="!filter" :size="size" @click="filter = ''">Löschen</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div :class="parentClass">
            <b-table
                ref="table"
                :table-class="localTableClass"
                :hover="localHover"
                :responsive="responsive"
                :sticky-header="stickyHeader"
                stacked="sm"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :items="items"
                :fields="fields"
                :busy.sync="isBusy"
                :sort-by.sync="localSortBy"
                :sort-desc="sortDesc"
                :filter="filter"
                :foot-clone="footer"
                :no-footer-sorting="noFooterSorting"
                :head-row-variant="headVariant"
                :table-variant="variant"
                :tbody-tr-class="selfStripedClass"
                show-empty
                @sort-changed="sortChanged"
                :per-page="perPage"
                :current-page="currentPage"
            >
                <template v-slot:table-busy>
                    <div class="text-center text-secondary my-2">
                        <strong>{{ busyText }}</strong>
                        <Spinner block small />
                    </div>
                </template>

                <template v-slot:empty>
                    <div class="text-center text-danger my-2">
                        <strong>{{ emptyText }}</strong>
                    </div>
                </template>

                <template v-slot:row-details="row">
                    <slot name="row-details" v-bind:row="row"></slot>
                </template>

                <template v-slot:thead-top="data">
                    <slot name="thead-top" v-bind:data="data"></slot>
                </template>

                <template v-for="field in fields" v-slot:[headConstraint(field.key)]="row">
                    <slot :name="'head(' + field.key + ')'" v-bind:row="row">{{ row.label }}</slot>
                </template>
                <!--<template v-for="field in fields" :slot="`head(${field.key})`" slot-scope="row">
                <slot :name="'head(' + field.key + ')'" v-bind:row="row">{{row.label}}</slot>
                </template>-->

                <template v-for="field in fields" v-slot:[cellConstraint(field.key)]="row">
                    <slot :name="field.key" v-bind:row="row">
                        {{
                        row.value
                        }}
                    </slot>
                </template>

                <template v-slot:cell(actions)="data">
                    <slot name="actions" v-bind:row="data.item">
                        <b-button
                            :size="size"
                            @click="
                                dataSelected(
                                    data.item,
                                    data.index,
                                    $event.target
                                )
                            "
                            variant="link"
                            class="mv-table-action-btn mr-1"
                        >Bearbeiten</b-button>
                        <b-button
                            :size="size"
                            @click="data.toggleDetails"
                            variant="link"
                            class="text-danger mv-table-action-btn"
                            disabled
                        >Löschen</b-button>
                    </slot>
                </template>

                <template v-slot:foot()="data">
                    <slot name="foot()" v-bind:data="data">
                        {{
                        data.label
                        }}
                    </slot>
                </template>

                <template v-slot:custom-foot="data">
                    <slot name="custom-foot" v-bind:data="data"></slot>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import Spinner from "@/components/Spinner/Spinner";

import "./Table.scss";
export default {
    name: "Table",
    components: {
        Spinner
    },
    props: [
        "tableClass",
        "hover",
        "variant",
        "headVariant",
        "striped",
        "bordered",
        "fields",
        "items",
        "sortBy",
        "sortDesc",
        "isBusy",
        "showFilter",
        "busyText",
        "emptyText",
        "modalTitle",
        "stickyHeader",
        "responsive",
        "selfStriped",
        "selfStripedKey",
        "footer",
        "noFooterSorting",
        "refresh",
        "perPage",
        "currentPage"
    ],
    data() {
        return {
            filter: null,
            small: null,
            localSortBy: this.sortBy,
            selfStripedData: {
                memory: null,
                currentClass: "even",
                parsedObjects: []
            }
        };
    },
    created() {
        const settings = this.$store.getters.getSettings;
        this.small = settings.size === "sm" ? true : null;
    },
    computed: {
        size() {
            const settings = this.$store.getters.getSettings;
            return settings.size;
        },
        localShowFilter() {
            return this.showFilter === "" || this.showFilter;
        },
        localHover() {
            return this.hover == false ? false : true;
        },
        localTableClass() {
            var cssClass = "";
            if (this.tableClass) {
                cssClass += this.tableClass;
            }
            return cssClass;
        },
        parentClass() {
            var cssClass = "";
            if(this.responsive === true && this.tableClass === 'mb-0') {
                cssClass += " table-responsive mb-0"
            } else if (this.responsive === true) {
                cssClass += " table-responsive";
            }
            if (this.stickyHeader === true) {
                cssClass += " b-table-sticky-header";
            }
            return cssClass;
        }
    },
    watch: {
        refresh: {
            handler() {
                this.$refs.table.refresh();
            }
        }
    },
    methods: {
        dataSelected(item, index, button) {
            this.$emit("dataSelected", index, item);
        },
        sortChanged(ctx) {
            this.$emit("sortChanged", ctx);
        },
        headConstraint(key) {
            return `head(${key})`;
        },
        cellConstraint(key) {
            return `cell(${key})`;
        },
        footConstraint(key) {
            return `foot(${key})`;
        },
        selfStripedClass(item, type) {
            if (this.selfStriped && this.selfStripedKey) {
                if (!item || type !== "row") return;
                const check = this.selfStripedData.parsedObjects.find(lItem => {
                    if (item.id) {
                        return lItem.id === item.id;
                    } else {
                        return lItem.day === item.day;
                    }
                });
                if (check) return check.rowClass;
                if (item.day && item.day !== this.selfStripedData.memory) {
                    if (this.selfStripedData.currentClass === "even") {
                        this.selfStripedData.currentClass = "odd";
                    } else {
                        this.selfStripedData.currentClass = "even";
                    }
                }
                if (item.day) {
                    this.selfStripedData.memory = item.day;
                }
                item.rowClass = this.selfStripedData.currentClass;
                this.selfStripedData.parsedObjects.push(item);
            }
            return;
        }
    }
};
</script>
